export default "__VITE_ASSET__EjZbAoNs__"